import { EpimsBaseEntityDto } from './epim-base.dto';
export class ClaimTypeDto extends EpimsBaseEntityDto {

    ClaimTypeId: string;

    ClaimTypeName: string;   
    
  SubscriptionUserId: string;
  SubscriberId: string;
  dateCreated: Date;
  dateUpdated?: Date;
  CreatedById: string;
  ModifiedById: string;
  SiteId: string;
  Version: number;
}